import { FCC } from "@/types/common";
import { TSettingColumn } from "@/types/enum";
import { createContext, useContext, useState } from "react";

type CompanySettingColumnType = {
  companySettingColumns: TSettingColumn[];
  defaultCompanySettingColumns: TSettingColumn[];
  handleSetCompanySettingColumns: (companyCols: TSettingColumn[]) => void;
};

export const CompanySettingColumnContext = createContext<CompanySettingColumnType | undefined>(undefined);

export const CompanySettingColumnProvider: FCC = ({ children }) => {
  const defaultCompanySettingColumns: TSettingColumn[] = [
    {
      key: "companyName",
      name: "所属機関名",
      isHidden: false,
    },
    {
      key: "companySpecificIndustry",
      name: "分野",
      isHidden: false,
    },
    {
      key: "workingAndLeftEmployeeCount",
      name: "支援人数",
      isHidden: false,
    },
    {
      key: "offeredEmployeeCount",
      name: "内定人数",
      isHidden: false,
    },
    {
      key: "supportFee",
      name: "支援委託料",
      isHidden: false,
    },
    {
      key: "companySupporter",
      name: "連絡担当者",
      isHidden: false,
    },
    {
      key: "rsoSupporter",
      name: "登録支援機関の担当",
      isHidden: false,
    },
    {
      key: "companyAddress",
      name: "本店住所",
      isHidden: false,
    },
    {
      key: "contractStartDate",
      name: "契約開始日",
      isHidden: true,
    },
  ];

  const [companySettingColumns, setCompanySettingColumns] = useState<TSettingColumn[]>(defaultCompanySettingColumns);

  const handleSetCompanySettingColumns = (companyCols: TSettingColumn[]) => {
    setCompanySettingColumns(companyCols);
  };

  return (
    <>
      <CompanySettingColumnContext.Provider value={{ companySettingColumns, handleSetCompanySettingColumns, defaultCompanySettingColumns }}>
        {children}
      </CompanySettingColumnContext.Provider>
    </>
  );
};

export const useCompanySettingColumn = (): CompanySettingColumnType => {
  const context = useContext(CompanySettingColumnContext);
  if (!context) {
    throw new Error("useCompanySettingColumn must be used within a CompanySettingColumnProvider");
  }
  return context;
};
